import React from 'react'

type Props = {
    Animal:string;
    Image:string;
}

const AnimalWithName = ({Animal, Image}: Props) => {
  return (
    <div className={`flex flex-col items-center`}>
        <img src={Image} alt={Animal} style={{ maxWidth:300 }}/>
        <h4 className="text-6xl font-extrabold" style={{ color:'#1c557a' }}><span className={`word-primary`}>{Animal.slice(0,1)}</span>{Animal.slice(1,)}</h4>
    </div>
  )
}

export default AnimalWithName